import * as types from '../constants/ActionTypes';

export const users = (state = {}, action) => {
    switch(action.type) {
        case types.LOGGED_IN_USER:
            return {
                ...state,
                ...action.user
            };
        case types.PURCHASE_VIP:
            return {
                ...state,
                ...action.user
            };
        case types.ADD_SCOIN:
            return {
                ...state,
                ...action.user
            };
        case types.PURCHASE_PACKAGE:
            return {
                ...state,
                ...action.user
            };
        case types.PURCHASE_DAY:
            return {
                ...state,
                ...action.user
            };
        case types.PURCHASE_MEDIA:
            return {
                ...state,
                ...action.user
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/users.js